import script from "./AppointmentSurveySuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentSurveySuccess.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentSurveySuccess.vue?vue&type=style&index=0&id=14868a3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14868a3c"]])

export default __exports__